<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.09506 5.25762L14.2205 8.79883C15.2276 9.51027 16.4218 10.0954 18.2416 10.0954C21.0744 10.0954 23.6417 8.19232 23.6417 8.19232L11.9465 0.111572C11.9465 0.111572 10.6704 1.51548 6.66553 4.01148C2.46087 6.63213 0.255859 7.39325 0.255859 7.39325L15.3993 17.8556L14.7268 18.2972L9.67728 14.8085C8.6702 14.0969 7.47599 13.5123 5.65603 13.5123C2.82322 13.5123 0.255859 15.4152 0.255859 15.4152L11.9513 23.4961C11.9513 23.4961 13.2275 22.092 17.2322 19.5962C21.4369 16.9754 23.6419 16.2143 23.6419 16.2143L8.42262 5.69948L9.09506 5.25762Z"
      fill="#DF013A"
    />
  </svg>
</template>
